export default __webpack_public_path__ + "static/media/long-arrow - Left.901f4a21.svg";